// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3PCr3","rootSuccess":"CompleteLink_rootSuccess__hzjfF","rootFailure":"CompleteLink_rootFailure__PmxPC","isDisabled":"CompleteLink_isDisabled__3Mb0S"};